export default __webpack_public_path__ + "static/homepage-ce9b46587195e00acd3d08fa304fb65e.mp4";